<template>
  <button @click.prevent="toggleMenu" class="header-menu-open">
    <base-icon v-if="!isOpen" class="icon-open" icon-name="open" width="29" height="26" viewBox="0 0 29 26">
      <open-icon></open-icon>
    </base-icon>
    <base-icon v-else class="icon-close" icon-name="close" width="26.87" height="26.87" viewBox="0 0 26.87 26.87">
      <close-icon></close-icon>
    </base-icon>
  </button>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { BaseIcon, CloseIcon, OpenIcon } from "@/components/icons";
  const emit = defineEmits(["closeMenu"]);
  const auctionStore = useAuctionStore();

  const isOpen = computed(() => {
    return auctionStore.isMobileMenuOpen;
  });

  const toggleMenu = () => {
    auctionStore.$patch({
      isMobileMenuOpen: !isOpen.value
    });
    document.body.classList.toggle("mobile-menu-open");

    if (!isOpen.value) {
      emit("closeMenu");
    }
  };
</script>
